var exports = {
  "l": "x31de4314--7f67bc--link-wrapper",
};

module.exports = exports;
